import store from "../../../store";
import { IItem } from "../items";
import { AbstractDocumentAlert } from "./AbstractDocumentAlert";
import { IConfiguration } from "../../../domain/configuration";

export class DepartmentEmptyAlert extends AbstractDocumentAlert {
  constructor() {
    super(true);
  }

  get detectedItem(): IItem {
    return null;
  }

  get kind(): string {
    const config = store.getters.configuration as IConfiguration;
    return config.wording.common.department + "チェック";
  }

  get target(): string {
    const config = store.getters.configuration as IConfiguration;
    return "文書属性(" + config.wording.common.department + ")";
  }

  get description(): string {
    const config = store.getters.configuration as IConfiguration;
    return config.wording.common.department + "を選択してください。";
  }

  get itemSetId(): number {
    return null;
  }
}
